import { createAsyncThunk } from "@reduxjs/toolkit";

import { getDashboardStats } from "../api/dashboard.api";
import { HRDashboardData } from "../types";

export const fetchDashboardStats = createAsyncThunk<
  HRDashboardData,
  void,
  {
    rejectValue: string;
  }
>("hrDashboard/fetchDashboardStats", async (_, { rejectWithValue }) => {
  try {
    return await getDashboardStats();
  } catch (error: any) {
    console.error("HR Dashboard API Error:", error);

    return rejectWithValue(
      error?.response?.data?.message ||
        error?.message ||
        "Unable to fetch HR dashboard statistics"
    );
  }
});